import {getRowsSourceLayer, mapIdsToValueStyle} from '../helper-functions/mapbox_helpers';
import {
  COLOR_UNAVAILABLE_ROW,
  COLOR_AVAILABLE_ROW,
  COLOR_SELECTED_ROW,
  LAYER_ROWS_ID,
  LAYER_ROWS_SOURCE,
  COLOR_HOVERED_ROW,
} from '../mapbox-constants/mapbox_constants';

function LayerRows(rowsConfig, venueConfigId, availableRows, selectedRowIds) {
  const coreLayerConfig = {
    id: LAYER_ROWS_ID,
    minzoom: rowsConfig.ZOOM_MIN_ROWS,
    type: 'line',
    visibility: 'visible',
    source: LAYER_ROWS_SOURCE,
    'source-layer': getRowsSourceLayer(venueConfigId),
    layout: {
      'line-join': 'bevel',
      'line-cap': 'square',
    },

    paint: {
      'line-color': rowsFillColor(availableRows, selectedRowIds),
      'line-width': {
        stops: rowsConfig.STOP_ROWS,
      },
    },
  };

  const resultConfig = coreLayerConfig;

  return resultConfig;
}

function rowsFillColor(rowIds, selectedRowsIds, hoveredRowsIds) {
  if (Array.isArray(rowIds) && rowIds.length > 0) {
    const availableRowsStyle = mapIdsToValueStyle(rowIds, COLOR_AVAILABLE_ROW);

    let selectedRowsStyle = [];
    let hoveredRowStyle = [];

    if (
      Array.isArray(selectedRowsIds) &&
      selectedRowsIds.length > 0 &&
      (!Array.isArray(hoveredRowsIds) || hoveredRowsIds.length === 0)
    ) {
      selectedRowsStyle = mapIdsToValueStyle(selectedRowsIds, COLOR_SELECTED_ROW);

      return [
        'match',
        ['get', 'urid'],
        ...selectedRowsStyle,
        ['match', ['get', 'urid'], ...availableRowsStyle, COLOR_UNAVAILABLE_ROW],
      ];
    } else if (
      Array.isArray(selectedRowsIds) &&
      selectedRowsIds.length > 0 &&
      Array.isArray(hoveredRowsIds) &&
      hoveredRowsIds.length > 0
    ) {
      selectedRowsStyle = mapIdsToValueStyle(selectedRowsIds, COLOR_SELECTED_ROW);
      hoveredRowStyle = mapIdsToValueStyle(hoveredRowsIds, COLOR_HOVERED_ROW);

      return [
        'match',
        ['get', 'urid'],
        ...selectedRowsStyle,
        [
          'match',
          ['get', 'urid'],
          ...hoveredRowStyle,
          ['match', ['get', 'urid'], ...availableRowsStyle, COLOR_UNAVAILABLE_ROW],
        ],
      ];
    } else if (
      (!Array.isArray(selectedRowsIds) || selectedRowsIds.length === 0) &&
      hoveredRowsIds &&
      hoveredRowsIds.length > 0
    ) {
      hoveredRowStyle = mapIdsToValueStyle(hoveredRowsIds, COLOR_HOVERED_ROW);

      return [
        'match',
        ['get', 'urid'],
        ...hoveredRowStyle,
        ['match', ['get', 'urid'], ...availableRowsStyle, COLOR_UNAVAILABLE_ROW],
      ];
    }

    return ['match', ['get', 'urid'], ...availableRowsStyle, COLOR_UNAVAILABLE_ROW];
  }

  return COLOR_UNAVAILABLE_ROW;
}

export {rowsFillColor};

export default {
  LayerRows,
  LayerRowsHighlight: LayerRows,
  rowsFillColor,
};
